module.exports = __webpack_public_path__ + "static/media/badge-sheriff.9b1eff62.svg";